<template>
  <v-container grid-list-xl>
    <v-layout wrap align-center>
      <dymoPrintPreview v-on:Modalclose="close" v-if="Printdialog" v-bind:assets="selected"/>
      <MagentoDetail
        v-on:mageModalclose="mageclose"
        v-bind:assetList="selected"
        v-if="magentoDialog"
      />
      <updateStatusDialog  v-on:dialogclose="deleteDialog = false" :deleteDialog="deleteDialog" :inputData="selected"/>

      <v-dialog v-model="overwritedialog" max-width="290">
        <v-card>
          <v-card-text>Record with same id found, overwrite?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat="flat" @click="overwritedialog = false">Cancel</v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="overwritedialog = false,confirmRewrite()"
            >Overwrite</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
     <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>

        <v-toolbar>
        <v-flex sm4>      
          <v-overflow-btn
            :items="phonebrandSetting"
            v-model="phoneBrandQuery"
            label="Brand"
            hide-details
          ></v-overflow-btn>
        </v-flex>
            <v-flex sm2>
            <v-text-field prepend-icon="search"
              v-model="modelQuery" label="Model" required>
            </v-text-field>
            </v-flex>
          
        <v-flex sm2>
       <v-overflow-btn
            :items="phoneSize"
            v-model="sizeQuery"
            label="Size"
            hide-details
          ></v-overflow-btn>
        </v-flex>
    
      
     <template v-slot:extension>
          <v-btn flat icon  title='search' @click="search"><v-icon>search</v-icon></v-btn>
          <v-btn icon title='clear filter'  @click="clear"><v-icon>clear</v-icon></v-btn>
           <v-spacer></v-spacer>
          <v-btn title='download CSV' :disabled="selected.length == 0" @click="csvOBJ" flat icon ><v-icon>cloud_download</v-icon></v-btn>
          <v-btn title='upload to magento' icon :disabled="selected.length == 0" @click.stop="magentoDialog = true" flat><img width='26px' src='https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/112651_development_435x512.png?alt=media&token=842aeaf9-f41d-4b86-a0d3-471952d2d437' /></v-btn>
          <v-btn title='update status' :disabled="selected.length == 0" @click.stop="deleteDialog = true" flat icon><v-icon>build</v-icon></v-btn>
       </template>
       
  </v-toolbar>
      

      <v-flex xs12>
        <v-data-table
          :rows-per-page-items="[50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
          v-model="selected"
          select-all
          item-key="Discovery.AssetTag"
          :headers="headers"
          :items="assetsArr"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td style="cursor : pointer " @click.stop="goTo(props.item)">
              <a>{{ props.item.Discovery.AssetTag }}</a>
            </td>
            <td>{{ props.item.Time }}</td>
            <td>{{ props.item.Discovery.Brand }}</td>
            <td>{{ props.item.Discovery.Model }}</td>
            <td>{{ props.item.Discovery.Imei}}</td>
            <td>{{ props.item.Discovery.Serial }}</td>
            
          </template>
          <template v-slot:footer>
            <td :colspan="10">
              <strong>{{selected.length}} items selected</strong>
            </td>
           
          </template>
        </v-data-table>
      </v-flex>
      <template></template>
    </v-layout>
  </v-container>
</template>
<script>
import updateStatusDialog from "../components/UpdateStatusDialog"
import dymoPrintPreview from "../components/PrintPreview.vue";
import MagentoDetail from "../components/MagentoDialog.vue";
import { mapFields } from "vuex-map-fields";
const fb = require("../firebaseConfig.js");
import { FireSQL } from 'firesql';
const { Parser } = require("json2csv");
export default {
  name: "assets",
  components: {
    updateStatusDialog,
    dymoPrintPreview,
    MagentoDetail,
  },
  computed: {
    ...mapFields([
    "phoneSize",
    "snackBarMessage",
    "snackBar",
    "snackBarcolor"
    ])
  },
  data() {
    return {
      magentoDialog: false,
      Printdialog: false,
      overwritedialog: false,
      selectedAsset: null,
      deleteDialog: false,
      selected: [],
      title: "Search phone",
      phonebrandSetting:  [],
      lotList: [],
      clientList: [],
      clientQuery: "",
      lotnumberQuery: "",
      sizeQuery: "",
      phoneBrandQuery: "",
      modelQuery: "",
      assetsArr: [],
      valid: true,
       items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Inventory',
          disabled: false,
          to: 'inventory'
        },
        {
          text: 'Phones',
          disabled: true,
          to: 'phoneAssets'
        }
      ],
      headers: [
        { text: "Asset", value: "Discovery.AssetTag", sortable: true },
        { text: "Created Time", value: "Time", sortable: true },
        { text: "Brand", value: "Discovery.Brand", sortable: true },
        { text: "Model", value: "Discovery.Model", sortable: true },
        { text: "IMEI", value: "Discovery.Imei", sortable: true },
        { text: "Serial", value: "Discovery.Serial", sortable: true },
        // { text: 'Actions', value:'' ,sortable: false }
      ]
    };
  },
  methods: {
    initData(){
        fb.AssetsCollections.where("AssetType","==","phone").orderBy("Time", "desc").limit(50).onSnapshot(querySnapshot=>{
       this.assetsArr = [];
       querySnapshot.forEach(doc => {
            if (doc.data().Discovery.Status === "ready") {
              this.assetsArr.push(doc.data());
            }
       })
    })
    },
    mageclose() {
      this.magentoDialog = false;
    },
    close() {
      this.Printdialog = false;
    },
    onClientSelect(item) {
      fb.CustomersCollections.doc(item)
        .get()
        .then(doc => {
          this.lotList = doc.data().locations;
        });
    },
    uploadJSON() {
      //triger file upload function by triggering the click on the hidden input
      this.$refs.jsonFile.value = "";
      this.$refs.jsonFile.click();
    },
    confirmRewrite() {
      fb.AssetsCollections.doc(this.uploadedjson.Discovery.AssetTag).set(
        this.uploadedjson
      );
     
    },
    deleteItem(input) {
      //remove asset from location if any
      fb.LocationsCollections.where(
        "assets",
        "array-contains",
        input.Discovery.AssetTag
      )
        .get()
        .then(items => {
          if (items.empty !== true) {
            items.forEach(item => {
              var docID = item.id;
              var collection = item.data().assets;
              collection = collection.filter(target => {
                return target !== input.Discovery.AssetTag;
              });
              fb.LocationsCollections.doc(docID).update({
                assets: collection
              });
            });
          }
        });
      //mark asset as recycled
      fb.AssetsCollections.doc(input.Discovery.AssetTag).update({
        ["Discovery.Status"]: "recycled"
      });
    },
    goTo(item) {
      this.$router.push("/assets/" + item.Discovery.AssetTag);
    },
    csvOBJ() {
      var json = this.selected.map(x => x.Discovery);
      const json2csvParser = new Parser({ flatten : true });
      const csv = json2csvParser.parse(json);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += csv;
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
      return json;
    },
    clear() {
      this.phoneBrandQuery = "";
      this.modelQuery = "";
      this.sizeQuery = "";
      this.clientQuery = "";
      this.lotnumberQuery = "";
      this.initData()
    },
    search() {
      var searchtype = ""
      var sql = ""
      if (this.phoneBrandQuery !== "") {
         sql = 'SELECT * FROM Assets where `Discovery.Brand` = "'+this.phoneBrandQuery+'" AND `Discovery.Status` = "ready" AND AssetType = "phone"'
      } 
      else if (this.sizeQuery !== "") {
         sql = 'SELECT * FROM Assets where `Discovery.Size` = "'+this.sizeQuery+'" AND `Discovery.Status` = "ready" AND AssetType = "phone"'
      } 
      else if (this.modelQuery !== "") {
         sql = 'SELECT * FROM Assets where `Discovery.Model` = "'+this.modelQuery+'" AND `Discovery.Status` = "ready" AND AssetType = "phone"'
      } 
      else {
        this.snackBarcolor = "error";
        this.snackBarMessage = "at least 1 filter is required";
        this.snackBar = true;
      }
      this.query(sql)
    },
       query(queryText,searchtype){
    this.assetsArr = [];
     const fireSQL = new FireSQL(fb.db)
           fireSQL.query(queryText).then(documents => {

            documents.forEach(doc => {
             this.assetsArr.push(doc);
          })
              if (this.modelQuery !== "") {
              this.assetsArr = this.assetsArr.filter(
                item => item.Discovery.Model == this.modelQuery
              );
            }
            if (this.sizeQuery !== "") {
              this.assetsArr = this.assetsArr.filter(
                item => item.Discovery.Size == this.sizeQuery
              );
            }
        })
      },
  },
   
  mounted() {

    fb.SettingsCollections.doc("searchDropDownValue").onSnapshot(doc => {
      this.phonebrandSetting = doc.data().phonebrandSetting;
      });
      this.initData()
  }
};
</script>
